module.exports = __webpack_public_path__ + "img/C08TechAshokasWill_ua.f9477c66.webp";